import React from "react";
import {Skeleton} from "antd"

import "../ServiceCard/servicecard.css";

export default ({size}) => {
  return (  <div
      
      className={`dm-home-service-card-skeleton ${
        size === "big"
          ? "dm-home-service-card-big"
          : "dm-home-service-card-small"
      }`}
    >
      <Skeleton avatar={{shape: "circle"}} paragraph={{rows: 1}} active/>
    </div>
  );
};

